import { render, staticRenderFns } from "./zhuchiren.vue?vue&type=template&id=5ef5a7fa&scoped=true&"
import script from "./zhuchiren.vue?vue&type=script&lang=js&"
export * from "./zhuchiren.vue?vue&type=script&lang=js&"
import style0 from "./zhuchiren.vue?vue&type=style&index=0&id=5ef5a7fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef5a7fa",
  null
  
)

export default component.exports